<ac-map-layer-provider
    [provider]="MapLayerProviderOptions.WebMapTileService"
    [options]="{ url: WORLD_OCEAN_BASE_URL, maximumLevel: 10, minimumLevel: 0 }"
></ac-map-layer-provider>
